import type { BlockSortOrder } from './types';

/**
 * Generic sort utility for channels, users, or any items with date and name fields.
 * Uses the same sort orders as sortBlocks (newest, oldest, alphabetical, random).
 */
export function sortItems<T>(
  items: T[],
  order: BlockSortOrder,
  dateField: keyof T = 'updatedAt' as keyof T,
  nameField: keyof T = 'title' as keyof T,
): T[] {
  const sorted = [...items];
  switch (order) {
    case 'oldest':
      return sorted.sort(
        (a, b) => new Date(a[dateField] as string).getTime() - new Date(b[dateField] as string).getTime(),
      );
    case 'alphabetical':
      return sorted.sort((a, b) =>
        String(a[nameField] || '').localeCompare(String(b[nameField] || '')),
      );
    case 'random':
      for (let i = sorted.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [sorted[i], sorted[j]] = [sorted[j], sorted[i]];
      }
      return sorted;
    case 'newest':
    default:
      return sorted.sort(
        (a, b) => new Date(b[dateField] as string).getTime() - new Date(a[dateField] as string).getTime(),
      );
  }
}
